const AllProperties = {
  $: 'PropertyResults',

  template: {
    $: 'PropertyItem',
    props: {
      showRooms: true,
      showPrice: true,
    },
  },

  props: {
    color: 'gray.600',
    gridProps: {
      gap: 7,
    },
    config: (props) => ({
      data: 'state.myaccount.0.allProperties',
      provide: ['myaccount'],
      limit: props.limit,
      template: props.template,
    }),
  },
};

export default AllProperties;
